import React from 'react'
import { useTheme } from '../../utils/useTheme'

export const AlertInfoIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref): React.ReactElement => {
    const theme = useTheme()
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M0 6.69087C0 2.9956 2.99561 0 6.69088 0H9.30913C13.0044 0 16 2.99561 16 6.69088V9.30913C16 13.0044 13.0044 16 9.30913 16H6.69087C2.9956 16 0 13.0044 0 9.30913V6.69087Z"
          fill={theme.tokens.background.brand.main.default}
        />
        <path
          d="M8 8.1698L8 11.4277"
          stroke={theme.tokens.foreground.main.staticWhite}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 5L8 5.05683"
          stroke={theme.tokens.foreground.main.staticWhite}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
)

export default AlertInfoIcon
